import React, { lazy } from 'react';
import Loadable from 'src/components/Loadable';

const MyCollectionView = Loadable(
  lazy(() => import('src/pages/manage/collections/MyCollectionPage'))
);
// Manage / Collection
const MyTemplatesListView = Loadable(
  lazy(() =>
    import('src/pages/manage/collections/templates/MyTemplatesListView')
  )
);
const MyTemplatesForm = Loadable(
  lazy(() => import('src/pages/manage/collections/templates/MyTemplatesForm'))
);
const MyApprovalRequestPage = Loadable(
  lazy(() =>
    import(
      'src/pages/manage/collections/approvalRequests/MyApprovalRequestPage'
    )
  )
);
const MyPsAssetsListView = Loadable(
  lazy(() => import('src/pages/manage/collections/psAssets/MyPsAssetsListView'))
);
const MyPsAssetsFormPage = Loadable(
  lazy(() => import('src/pages/manage/collections/psAssets/MyPsAssetsFormPage'))
);
const MyAppsListView = Loadable(
  lazy(() => import('src/pages/manage/collections/apps/MyAppsListView'))
);
const MyAppsFormPage = Loadable(
  lazy(() => import('src/pages/manage/collections/apps/MyAppsFormPage'))
);
const MyMobileAppListPage = Loadable(
  lazy(() =>
    import('src/pages/manage/collections/mobileApps/MyMobileAppListPage')
  )
);
const MyMobileAppFormPage = Loadable(
  lazy(() =>
    import('src/pages/manage/collections/mobileApps/MyMobileAppFormPage')
  )
);
const MySnippetListPage = Loadable(
  lazy(() => import('src/pages/manage/collections/snippets/MySnippetListPage'))
);
const MySnippetFormPage = Loadable(
  lazy(() => import('src/pages/manage/collections/snippets/MySnippetFormPage'))
);

const routes = [
  { path: 'manage/my-collections', element: <MyCollectionView /> },
  {
    path: 'manage/my-collections/templates',
    element: <MyTemplatesListView />
  },
  {
    path: 'manage/my-collections/templates/new',
    element: <MyTemplatesForm />
  },
  {
    path: 'manage/my-collections/templates/:id',
    element: <MyTemplatesForm />
  },
  {
    path: 'manage/my-collections/apps',
    element: <MyAppsListView />
  },
  {
    path: 'manage/my-collections/apps/new',
    element: <MyAppsFormPage />
  },
  {
    path: 'manage/my-collections/apps/:id',
    element: <MyAppsFormPage />
  },
  {
    path: 'manage/my-collections/mobile-apps',
    element: <MyMobileAppListPage />
  },
  {
    path: 'manage/my-collections/mobile-apps/new',
    element: <MyMobileAppFormPage />
  },
  {
    path: 'manage/my-collections/mobile-apps/:id',
    element: <MyMobileAppFormPage />
  },
  {
    id: 'my-ps-assets',
    path: 'manage/my-collections/ps-assets',
    element: <MyPsAssetsListView />,
    handle: {
      isEAP: true
    }
  },
  {
    id: 'my-ps-assets-new',
    path: 'manage/my-collections/ps-assets/new',
    element: <MyPsAssetsFormPage />,
    handle: {
      isEAP: true
    }
  },
  {
    id: 'my-ps-assets-edit',
    path: 'manage/my-collections/ps-assets/:id',
    element: <MyPsAssetsFormPage />,
    handle: {
      isEAP: true
    }
  },
  {
    path: 'manage/my-collections/snippets',
    element: <MySnippetListPage />
  },
  {
    path: 'manage/my-collections/snippets/new',
    element: <MySnippetFormPage />
  },
  {
    path: 'manage/my-collections/snippets/:id',
    element: <MySnippetFormPage />
  },
  {
    path: 'manage/my-collections/approval-requests',
    element: <MyApprovalRequestPage />
  }
];

export default routes;
